import { ColumnTypesEnum, ProjectDto } from '@/core';
import { getColumnSettings } from '@/pages/Projects.Constructor';

export const validateColumnsTab = (projectData: ProjectDto) => {
  const quantityOfRequiredColumns = Object.values(ColumnTypesEnum).filter(
    (type) => getColumnSettings(type).isRequired,
  ).length;
  return (
    projectData.columns.filter((column) => getColumnSettings(column.type).isRequired).length ===
    quantityOfRequiredColumns
  );
};
